(function() {


  // ------------- CONFIGURATION OPTIONS -------------- //
  // {
  //   alertType: String - 'success' || 'warn' || 'error' || 'info'
  //   title: String - The title of the alert,
  //   message: String - The message of the alert,
  //   suppressIcon: Boolean (optional) - pass false to hide the icon, otherwise it will show
  //   action: Object - Implementation is TBD
  // }


  var linkFunction = function($scope, element, attrs) {
  }

  var controllerFunction = function($scope, UserSession) {
    $scope.wcmContent = wcmContent;
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/achRenewal/achRenewal.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession"]; angular.module('cvsApp').directive('achRenewal', directiveFunction);

})();
